export default __webpack_public_path__ + "static/media/station_1_icon.4fc9f0ee.png";